import { CityState, DataSource, HorizontalSpacer, Layout, Location, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementSearch extends Layout {
    citystateStopDestCityId: CityState;
    citystateStopOriginCityId: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerEquipment: HorizontalSpacer;
    horizontalspacerLocation: HorizontalSpacer;
    panelConsigneeLocation: Panel;
    panelMovementFields: Panel;
    panelMovementListContainer: Panel;
    panelSearchEquipment: Panel;
    panelShipperLocation: Panel;
    searchpanelMovements: SearchPanel;
    sourceMovementList: DataSource;
    switchAuthorized: Switch;
    switchBrokerage: Switch;
    switchLoaded: Switch;
    tableMovements: Table;
    textboxBrokerageStatus: Textbox;
    textboxDeliveryDateRange: Textbox;
    textboxDestLocation: Location;
    textboxDolly1Id: Textbox;
    textboxDolly2Id: Textbox;
    textboxDriver1Name: Textbox;
    textboxDriver2Name: Textbox;
    textboxId: Textbox;
    textboxOrdersId: Textbox;
    textboxOriginLocation: Location;
    textboxPickupDateRange: Textbox;
    textboxStatus: Textbox;
    textboxStopDestAddress2: Textbox;
    textboxStopDestAddress: Textbox;
    textboxStopDestLocationId: Textbox;
    textboxStopDestLocationName: Textbox;
    textboxStopOriginAddress2: Textbox;
    textboxStopOriginAddress: Textbox;
    textboxStopOriginLocationId: Textbox;
    textboxStopOriginLocationName: Textbox;
    textboxTractorid: Textbox;
    textboxTrailer2Id: Textbox;
    textboxTrailer3Id: Textbox;
    textboxTrailerId: Textbox;
    textboxXfer2settleDate: Textbox;
}
